<template>
    <div class="pages coupon">
        <div class="f1 mb-30">
            <div class="d1">
                使用优惠券体系结合会员中台，营销效果更佳
            </div>
            <div class="d2">
                <div class="text">
                  <p> 快去设置基于优惠券的自动化营销体系吧～ <span style="display:block">查看如何使用</span></p>
                </div>
                <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
            </div>
        </div>
        <div class="f2 mb-30">
            <div class="li">
                <div>
                    <p>代金券</p>
                    <p>代金券可无门槛在购物中抵扣同样等值的现金使用</p>
                </div>
                <div>
                    <p>
                        <span>19,999</span>
                        <span>发放数量</span>
                    </p>
                    <p>
                        <span>9</span>
                        <span>使用数量</span>
                    </p>
                </div>
            </div>
            <div class="li">
                <div>
                    <p>满减券</p>
                    <p>是指在消费时达到相应的金额后，可以用来抵扣物品（商品）部分价格的一种券</p>
                </div>
                <div>
                    <p>
                        <span>19,999</span>
                        <span>发放数量</span>
                    </p>
                    <p>
                        <span>9</span>
                        <span>使用数量</span>
                    </p>
                </div>
            </div>
            <div class="li">
                <div>
                    <p>折扣券</p>
                    <p>在商品金额基础上按折扣券所规定的比例折扣计价</p>
                </div>
                <div>
                    <p>
                        <span>19,999</span>
                        <span>发放数量</span>
                    </p>
                    <p>
                        <span>9</span>
                        <span>使用数量</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="f3">
             <el-form :inline="true" label-width="100px" :model="query" class="demo-form-inline">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item class="formItem" label="优惠券名称：">
                            <el-input
                            class="iptRdio"
                            placeholder="请搜索客户昵称/手机号"
                             suffix-icon="el-icon-search"
                            v-model="query.keyword_search"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="优惠券类型：">
                            <el-select class="iptRdio" v-model="value1" placeholder="请选择优惠券类型">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="优惠券状态：">
                            <el-select class="iptRdio" v-model="value2" placeholder="请选择优惠券状态">
                                <el-option
                                v-for="item in options2"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <div style="text-align: right;">
                            <el-button  class="reson" type="primary" round ><img style="width:16px;height:16px;vertical-align: middle;" src="../../assets/images/newIcon/margetmiddle_screen_icon.png" alt=""> 筛选</el-button>
                            <el-button  class="reson" type="primary" round icon="el-icon-refresh-right">重置</el-button>
                           
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item class="formItem" label="业务系统：">
                             <el-select class="iptRdio" v-model="value3" placeholder="请选择适用渠道">
                                <el-option
                                v-for="item in options3"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="发放方式：">
                            <el-select class="iptRdio" v-model="value4" placeholder="请选择适用渠道">
                                <el-option
                                v-for="item in options4"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                            <el-form-item class="formItem formItem2" label="">
                        </el-form-item>
                    </el-col>
                   
                </el-row>
            </el-form>
        </div>
        <div class="f4 bf">
            <div class="d1">
                <p>共<span>{{total}}</span>条</p>
                <p>
                    <el-button @click="showPopup(3)" plain class="kh-btn"><img src="../../assets/images/newIcon/margetmiddle_derive_icon.png" alt=""> 导出</el-button>
                    <el-button @click="newCoupon" style="background:#327EFF;" type="primary" round><img src="../../assets/images/newIcon/margetmiddle_coupons_icon.png" alt=""> 新增优惠券</el-button>
                </p>
            </div>
            <el-table
                :data="tableData3"
                :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                style="width: 100%;"
                :cell-style="{textAlign: 'center',fontSize:'12px'}"
                >
                <el-table-column
                prop="name"
                label="优惠券名称"
                show-overflow-tooltip
                >
                </el-table-column>

                <el-table-column
                prop="number"
                label="类型"
                >
                </el-table-column>
                <el-table-column
                prop="xmember"
                label="业务系统"
                
                cell-style="background:red;"
                >
                </el-table-column>
                <el-table-column
                prop="lmember"
                label="发放方式"
               >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="内容"
                >
                </el-table-column>
                <el-table-column
                prop="status"
                label="状态"
                >
                </el-table-column>
                <el-table-column
                prop="num"
                label="已领取"
                >
                </el-table-column>
                <el-table-column
                prop="num"
                label="剩余"
                >
                </el-table-column>
                <el-table-column
                prop="num"
                label="已使用"
                >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="操作"
                width='200'
                >
                    <template slot-scope="scope">
                        <el-button type="text" @click="goDetail">详情</el-button>
                        <el-button @click="edit(4)" type="text">编辑</el-button>
                        <el-button @click="del(4)" type="text">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="margin-top: 24px;"
            :current-page="query.page_index"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="query.page_size"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
export default {
    data() {
        return {
            options: [{
                value: '选项1',
                label: '满减券'
                }, {
                value: '选项2',
                label: '折扣券'
            }, {
                value: '选项2',
                label: '代金券'
            }],
            options2: [{
                value: '选项1',
                label: '发送中'
                }, {
                value: '选项2',
                label: '已结束'
            }],
            options3: [{
                value: '选项1',
                label: '小橘帮帮'
                }, {
                value: '选项2',
                label: '颐和中台'
            }],
            options4: [{
                value: '选项1',
                label: '活动发放'
                }, {
                value: '选项2',
                label: '用户领取'
            }, {
                value: '选项2',
                label: '等级发放'
            }],
            query:JSON.parse(JSON.stringify(QUERY)),
            time:"",
            total:100,
            value: '',
            value1: '',
            value2: '',
            value3: '',
            value4: '',
            tableData3: [{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"活动发放",
                labellv:"满99,减10%",
                status:"发送中",
                num:'100'
                },{
                name: '6.1活动券',
                number:"折扣券",
                xmember:"业务系统",
                lmember:"用户领取",
                labellv:"满99,减10%",
                status:"发送中",
                num:'100'
                },{
                name: '双11大额优惠券',
                number:"代金券",
                xmember:"业务系统",
                lmember:"等级发放",
                labellv:"满99,减10%",
                status:"发送中",
                num:'100'
                },{
                name: '特大聚汇活动',
                number:"满减券",
                xmember:"积分商城",
                lmember:"活动发放",
                labellv:"满99,减10%",
                status:"发送中",
                num:'100'
                },{
                name: '双12活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"活动发放",
                labellv:"满99,减10%",
                status:"发送中",
                num:'100'
                },{
                name: '十月一活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"活动发放",
                labellv:"满99,减10%",
                status:"发送中",
                num:'100'
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"活动发放",
                labellv:"满99,减10%",
                status:"发送中",
                num:'100'
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"活动发放",
                labellv:"满99,减10%",
                status:"发送中",
                num:'100'
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"活动发放",
                labellv:"满99,减10%",
                status:"发送中",
                num:'100'
            },],
        }
    },
    methods:{
        edit(){
            this.$router.push({name:"newCoupons"})
        },
        del(){
             this.$confirm('是否确定删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
            this.$message({
                type: 'success',
                message: '删除成功!'
            });
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });          
            });
        },
        newCoupon(){
            this.$router.push({name:"newCoupons",query:{id:"111"}})
        },
        goDetail(){
            this.$router.push({name:"couponDetails",query:{id:'111'}})
        }
    }
}
</script>
<style lang="less" scoped>
    .coupon{
        .f1{
            display: flex;
            justify-content: space-between;
            .d1{
                height:106px;
                box-sizing: border-box;
                padding-right: 6%;
                padding-left: 4%;
                padding-top: 30px;
                width:65%;
                 background:url('../../assets/images/newIcon/jijmu_title_bg.png') no-repeat;
                 background-size:100% 100%;
                font-size: 21px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 24px;
                letter-spacing: 7px;
            }
            .d2{
                width:34%;
                display: flex;
                align-items: center;
                height:106px;
                .text{
                    width:100%;
                    display: flex;
                    align-items: center;

                    padding:4px 30px;
                    // background: #fff;
                    height:100%;
                    font-size: 14px;
                    font-weight: 500;
                    color: #333333;
                    img{
                        width:305px;
                    }
                    span{
                        font-size: 14px;
                        font-weight: 500;
                        color: #327EFF;
                    }
                    background: url('../../assets/images/newIcon/popupwindow_background.png') no-repeat;
                    background-size:100% 100%;
                }
 
                img{
                    width:58px;
                    height:58px;
                }
               
            }
        }
        .f2{
                display: flex;
                // justify-content: space-between;
                .li{
                    margin-right:1%;
                    width:24%;
                    box-sizing: border-box;
                    background: #fff;
                    border-radius: 10px;
                    div{
                        &:first-child{
                            box-sizing: border-box;
                            height:100px;
                            background: url('../../assets/images/newIcon/group_recommend_bc.png') no-repeat;
                            padding:0px 15px;
                            padding-top:20px;
                            margin:0 10px;
                            margin-top:15px;
                            background-size:100% 100%;
                            color:#fff;
                            p{
                                &:first-child{
                                    margin-bottom:10px;
                                    font-size: 16px;
                                    font-weight: 500;
                                    color: #FFFFFF;
                                }
                                &:last-child{
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #FFFFFF;
                                }
                            }
                        }
                        &:nth-child(2){
                            display: flex;
                            margin:20px 0;
                            p{
                                width:50%;
                                text-align: center;
                                border-right:1px solid #E6E6E6;
                                span{
                                    display: block;
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #666666;
                                    &:first-child{
                                        margin-bottom:10px;
                                        font-size: 20px;
                                        font-weight: bold;
                                        color: #327EFF;
                                    }
                                }
                                &:last-child{
                                    border:0;
                                }
                            }
                        }
                        &:nth-child(3){
                            display: flex;
                            border-top:1px solid #EDEDED;
                            p{
                                &:first-child{
                                    border-right:1px solid #ededed;
                                }
                                padding:15px;
                                width:100%;
                                text-align: center;
                                img{
                                    margin-right:10px;
                                    width:16px;
                                    height:16px;
                                    vertical-align: middle;
                                }
                                span{
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #3285F8;
                                }
                            }
                        }
                    }
                }
        }
        .f3{
            // background: #fff;
            .el-form{
                // padding:30px 15px;
                padding-bottom:15px;
            }
            /deep/ .el-form-item{
                display: flex;
                align-items: center;
            }
            //  padding:30px;
           /deep/ .el-col-3{
               width:15.5%;
           }
           /deep/ .el-col-6{
               width:26%;
           }
            .icons{
                padding: 2px;
                margin-left:10px;
                color: rgb(255, 255, 255);
                background: rgb(46, 108, 246);
                border-radius: 50%;
            }
            .reson.el-button{
                background: #2E6CF6;
            }
           
            .times.el-input__inner{
                border-radius: 30px;
                width:100%;
                height:38px;
                .el-range-separator{
                    font-size:16px;
                    color:#ccc;
                    line-height: 28px;
                }
            }
            /deep/ .formItem.el-form-item{
                width:100%;
            }
            /deep/ .el-select{
                width: 100%;
            }
            /deep/ .formItem2  .el-form-item__content{
                // width:66%;
            }
            /deep/ .el-form-item__content{
                width:calc(100% - 100px);
            }
        }
        .f4{
            border-radius: 8px;
            .d1{
                padding:15px;
                p{
                    &:first-child{
                        margin-left:30px;
                        font-size: 16px;
                        font-weight: 500;
                        color: #333940;
                        span{
                            color:#327EFF;
                        }
                    }
                    
                }
                display: flex;
                justify-content: space-between;
                img{
                    width:16px;
                    height:16px;
                    vertical-align: middle;
                }
                .kh-btn.el-button{
                    border-radius: 15px;
                    border: 1px solid #327EFF;
                    color:#327EFF;
                }
            }
            /deep/ .el-checkbox__inner{
                border-radius: 15px;
            }
            .labelLi{
                display: flex;
                align-items: center;
                justify-content: center;
                p{
                    margin-right:8px;
                    display: inline-block;
                    width:40px;
                    padding:0px 8px;
                    background: rgba(211, 236, 255, 0.4);
                    border-radius: 15px;
                    border: 1px solid rgba(0, 145, 255, 0.11);
                    font-size: 12px;
                    font-weight: 400;
                    color: #0091FF;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    // &:last-child{
                    //     padding:0 4px;
                    //     text-align: center;
                    //     // border:0;
                    //     // background:#fff;
                    // }
                    
                }
                .s{
                    background: rgba(211, 236, 255, 0.4);
                    border: 1px solid rgba(0, 145, 255, 0.11);
                    padding: 2px 10px;
                    color: #0091FF;
                    border-radius: 18px;
                    width: auto;
                }
            }
        }
        /deep/ .el-range-editor--mini .el-range-separator{
            font-size: 16px;
            color: #ccc;
            line-height: 28px;
        }
        /deep/ .iptRdio .el-input__inner{
            border-radius: 30px;
            height:38px;
        }
        /deep/ .iptRdio  .el-input__inner{
            background: #fff;
        }
    }
</style>